import styled from '@emotion/styled';
import Tabs, {Tab} from "patient-ping-remedy/packages/tabs";
import {TabProps} from "patient-ping-remedy/packages/tabs/lib/Tab";
import {colors, sizes} from "patient-ping-remedy/packages/theme";
import {css} from "@emotion/react";

const StyledTabDiv = styled.div((props: {display: string}) => ({
  display: props.display,
}));

const StyledTabs = styled(Tabs)`
  display: flex;
  gap: ${sizes.xSmall};
  padding-top: 0;
  margin-bottom: 2rem;
  border: none;
`;

const StyledTab = styled(
  (props: TabProps) => <div><Tab {...props} /></div>)(
  (props) => css`
    cursor: pointer;
    font-family: 'Libre Franklin', sans-serif;
    text-transform: none;
    font-weight: 600;
    font-size: 1.6rem;
    letter-spacing: 1px;
    color: ${colors.primary1};
    background-color: transparent;
    border-radius: 0;
    border-bottom: ${props.active ? `5px solid ${colors.primary1}` : 'none'};

    &:hover {
      color: ${colors.primary1};
      background-color: transparent;
      border-bottom: 5px solid ${colors.primary1};
    }

    &:active {
      background-color: transparent;
    }
`);

const HiddenTab = styled.div`
  display: none;
`;

export { StyledTabDiv, StyledTabs, StyledTab, HiddenTab };
